import React, { useRef, useState, useContext } from "react";
import { useNavigate, useLocation } from "react-router";
import AuthenticationService from "../../Services/AuthenticationService";
import "../../Assets/css/bootstrap.css";
import LoadingIndicator from "../CommonComponent/LoadingIndicator";
import AuthContext from '../AuthContextComponent/AuthContext';
import { ReactComponent as LoginButtonIcon } from '../../Assets/img/Login.svg';
import { ReactComponent as Error } from '../../Assets/img/Error.svg';
import TopBackground from '../../Assets/img/LoginTopBackground.png';
import BottomBackground from '../../Assets/img/LoginBottomBacckground.png';
import ProductLogo from '../../Assets/img/ProductLogo.png';

function Login() {
    let navigate = useNavigate();
    const location = useLocation();
    const authCtx = useContext(AuthContext);

    const usernameRef = useRef();
    const passwordRef = useRef();

    const [hasLoginFailed, setHasLoginFailed] = useState(false);
    const [loginError, setLoginError] = useState("Login Failed");
    // Set by whoever redirected here -- e.g. a completed password change, which ends the session
    // on purpose, so the user needs telling that this was the intended outcome.
    const [successMessage, setSuccessMessage] = useState(location.state?.message || "");
    const [isLoading, setIsLoading] = useState(false);

    function loginClicked(event) {
        event.preventDefault();
        setIsLoading(true);
        // Stale once a new attempt starts; an error must not appear beneath it.
        setSuccessMessage("");

        const enteredUsername = usernameRef.current.value;
        const enteredPassword = passwordRef.current.value;

        const loginDTO = {
            request: {
                Username: enteredUsername,
                Password: enteredPassword
            }
        };

        AuthenticationService.Authenticate(loginDTO)
            .then((response) => {
                if (response.data.response == null) {
                    setIsLoading(false);
                    setHasLoginFailed(true);
                    setLoginError(response.data.errors?.[0]?.message || "Login Failed");
                    return;
                }

                AuthenticationService.registerSuccessfulLoginForJwt(
                    enteredUsername,
                    response.data.response.authenticationToken,
                    response.headers["set-cookie"]
                );

                // The password was set by an administrator. Establish just enough session to reach the
                // change-password screen and stop -- App.js short-circuits every route while this is
                // set, and the server independently rejects everything except the password change.
                if (response.data.response.mustChangePassword) {
                    authCtx.login(response.data.response.role, null);
                    authCtx.selectUser(enteredUsername);
                    authCtx.setMustChangePassword(true);
                    navigate("/Change-password", { replace: true });
                    return;
                }

                if (response.data.response.role === "Partner") {
                    authCtx.login(response.data.response.role, null);
                    authCtx.Tenant();
                    authCtx.selectUser(enteredUsername);
                    navigate("/Devices");
                }
                else {
                    // SelectTenant.js/SelectTenantPopup.js fetch their own options fresh from
                    // PartnerService.getPartners() on mount now, so there's no need to seed
                    // authCtx.tenants from the login response.
                    authCtx.login(response.data.response.role, null);
                    authCtx.selectUser(enteredUsername);

                    if (response.data.response.isTenantSelected) {
                        authCtx.Tenant();
                        authCtx.selectCountry(response.data.response.countryName);
                        authCtx.selectPartner(response.data.response.partnerName);
                        navigate("/Devices");
                    }
                    else if (response.data.response.requiresTenantSelection) {
                        // More than one partner exists and none is selected -- ambiguous, let the
                        // admin pick. replace, not push: same back-button-safety reasoning as below.
                        navigate("/selectTenant", { replace: true });
                    }
                    else {
                        // No partner registered yet -- land on the Partners screen to register one.
                        // replace, not push: prevents browser Back from returning to a stale
                        // logged-in-but-no-tenant /login entry (which falls through to ForceLogout)
                        navigate("/Partners", { replace: true });
                    }
                }
            })
            .catch(() => {
                setIsLoading(false);
                setHasLoginFailed(true);
                setLoginError("Login Failed");
            });
    }

    if (isLoading) {
        return (
            <div className="container">
                <LoadingIndicator size="large" message="Logging..." />
            </div>
        );
    }

    return (
        <div className="outercontainer">
            <img src={TopBackground} className="topbackground" alt="fireSpot" />
            <img src={ProductLogo} className="productlogo" alt="fireSpot" />
            <div className="logincontainer">
                <div className="insidecontainer">
                    <span className="loginheader">Login</span>
                    {hasLoginFailed && (
                        <div className="alert alert-warning"><Error /><span className="message-popup-title">{loginError}</span></div>
                    )}
                    {successMessage && (
                        <div className="alert alert-success">{successMessage}</div>
                    )}
                    <form onSubmit={loginClicked} className="form">
                        <div className="mb-3">
                            <label className="username_label">User Name</label>
                            <br />
                            <input
                                type="text"
                                ref={usernameRef}
                                className="inputbox"
                                //placeholder="Enter username"
                                required
                            />
                        </div>
                        <div className="mb-3">
                            <label className="username_label">Password</label>
                            <input
                                type="password"
                                ref={passwordRef}
                                className="inputbox"
                                //placeholder="Enter password"
                                required
                            />
                        </div>
                        <br />
                        <button type="submit" className="login_button">
                            <LoginButtonIcon />
                            <text className="button_text">Login</text>
                        </button>
                    </form>
                </div>
            </div>
            <img src={BottomBackground} className="bottombackground" alt="fireSpot" />
        </div>
    );
}

export default Login;
